<template>
  <boxwrap class="codes--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          @click="deleteData(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'inactive'"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          @click="restore(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'deleted'"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          title="modify"
          @click="update()"
          v-if="selected.length > 0 &&
            $route.params.status !== 'deleted'"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="checkbox"
              >
              <checkbox>
                <input
                  type="checkbox"
                  @click="checkAll(codes)"
                  :checked="selectAll"
                />
              </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                <span>no</span>
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>created at</span>
              </tbl-td>

              <tbl-td
                name="code"
                :sort="true"
                @click.native="sort('code')"
                v-if="checkCol('code', tblSetting)"
              >
                <span>code</span>
              </tbl-td>

              <tbl-td
                name="code-name"
                :sort="true"
                @click.native="sort('name')"
                v-if="checkCol('code_name', tblSetting)"
              >
                <span>code name</span>
              </tbl-td>

              <tbl-td
                name="users-total"
                :sort="true"
                @click.native="sort('users_total')"
                v-if="checkCol('users_total', tblSetting)"
              >
                <span>users total</span>
              </tbl-td>

              <tbl-td
                name="users-confirm"
                :sort="true"
                @click.native="sort('users_confirm')"
                v-if="checkCol('users_confirm', tblSetting)"
              >
                <span>users confirm</span>
              </tbl-td>

              <tbl-td
                name="users-reject"
                :sort="true"
                @click.native="sort('users_reject')"
                v-if="checkCol('users_reject', tblSetting)"
              >
                <span>users reject</span>
              </tbl-td>

              <tbl-td
                name="users-ban"
                :sort="true"
                @click.native="sort('users_ban')"
                v-if="checkCol('users_ban', tblSetting)"
              >
                <span>users ban</span>
              </tbl-td>

              <tbl-td
                name="users-delete"
                :sort="true"
                @click.native="sort('users_delete')"
                v-if="checkCol('users_delete', tblSetting)"
              >
                <span>users delete</span>
              </tbl-td>

              <tbl-td
                name="agent-id"
                :sort="true"
                @click.native="sort('agents.login_id')"
                v-if="checkCol('agent_id', tblSetting)"
              >
                <span>agent id</span>
              </tbl-td>

              <tbl-td
                name="agent-name"
                :sort="true"
                @click.native="sort('agents.login_name')"
                v-if="checkCol('agent_name', tblSetting)"
              >
                <span>agent name</span>
              </tbl-td>

              <tbl-td
                class="bank-name"
                :sort="true"
                @click.native="sort('deposit.name')"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span>bank name</span>
              </tbl-td>

              <tbl-td
                class="bank-account-name"
                :sort="true"
                @click.native="sort('deposit.bank_account_name')"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span>bank account name</span>
              </tbl-td>

              <tbl-td
                class="bank-number"
                :sort="true"
                @click.native="sort('deposit.bank_number')"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span>bank number</span>
              </tbl-td>

<!--               <tbl-td
                name="code"
                :sort="true"
                v-if="checkCol('code', tblSetting)"
                @click.native="sort('code')"
              >
                <span>code</span>
              </tbl-td> -->

              <tbl-td
                name="active"
                :sort="true"
                @click.native="sort('active')"
                v-if="checkCol('active', tblSetting)"
              >
                <span>active</span>
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span>updated at</span>
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span>deleted at</span>
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="code in codes"
              :key="code.id"
              :class="{'-inactive': code.inactive, 'is-deleted': code.deleted_at }"
            >
              <tbl-td
                name="checkbox"
              >
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="code.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                <span>{{ code.id }}</span>
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>{{ code.created_at | date }}</span>
              </tbl-td>

              <tbl-td
                name="code"
                v-if="checkCol('code', tblSetting)"
              >
                <span>{{ code.code }}</span>
              </tbl-td>

              <tbl-td
                name="code-name"
                v-if="checkCol('code_name', tblSetting)"
              >
                <span>{{ code.name }}</span>
              </tbl-td>

              <tbl-td
                name="users-total"
                v-if="checkCol('users_total', tblSetting)"
              >
                <span>{{ code.users_total }}</span>
              </tbl-td>

              <tbl-td
                name="users-confirm"
                v-if="checkCol('users_confirm', tblSetting)"
              >
                <span>{{ code.users_confirm }}</span>
              </tbl-td>

              <tbl-td
                name="users-reject"
                v-if="checkCol('users_reject', tblSetting)"
              >
                <span>{{ code.users_reject }}</span>
              </tbl-td>

              <tbl-td
                name="users-ban"
                v-if="checkCol('users_ban', tblSetting)"
              >
                <span>{{ code.users_ban }}</span>
              </tbl-td>

              <tbl-td
                name="users-delete"
                v-if="checkCol('users_delete', tblSetting)"
              >
                <span>{{ code.users_delete }}</span>
              </tbl-td>

              <tbl-td
                name="agent-id"
                v-if="checkCol('agent_id', tblSetting)"
              >
                <span>{{ code.agent.login_id }}</span>
              </tbl-td>

              <tbl-td
                name="agent-name"
                v-if="checkCol('agent_name', tblSetting)"
              >
                <span> {{ code.agent.login_name }}</span>
              </tbl-td>

              <tbl-td
                class="bank-name"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span v-if="code.deposit">{{ code.deposit.bank_name }}</span>
              </tbl-td>

              <tbl-td
                class="bank-account-name"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span v-if="code.deposit">{{ code.deposit.bank_account_name }}</span>
              </tbl-td>

              <tbl-td
                class="bank-number"
                v-if="checkCol('wallets', tblSetting)"
              >
                <span v-if="code.deposit">{{ code.deposit.bank_number }}</span>
              </tbl-td>

<!--               <tbl-td
                name="code"
                v-if="checkCol('code', tblSetting)"
              >
                <span> {{ code.code }}</span>
              </tbl-td> -->

              <tbl-td
                name="active"
                v-if="checkCol('active', tblSetting)"
              >
                <select-list
                  :title="code.active ? 'active' : 'inactive'"
                  :withReset="true"
                  v-model="code.active"
                  v-if="checkPermission"
                  @reset="resetTrigger(code)"
                >
                  <select-option
                    :value="false"
                    :name="'inactive'"
                    @click.native="setSelected(code)"
                    v-if="code.active"
                  >
                    inactive
                  </select-option>

                  <select-option
                    :value="true"
                    :name="'active'"
                    @click.native="setSelected(code)"
                    v-if="!code.active"
                  >
                    active
                  </select-option>
                </select-list>
                <span v-else>{{ code.active ? 'active' : 'inactive' }}</span>
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span>{{code.updated_at | date}}</span>
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span>{{ code.deleted_at | date }}</span>
              </tbl-td>

            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="1"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-code"
      title="create code"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>deposit name</span></div>
            <div class="form-data">
              <div class="input-wrap">

                <select-list
                  :title="depositAcc.name"
                  :withReset="true"
                  v-model="depositAcc.id"
                >
                  <select-option
                    v-for="acc in depositAccounts"
                    :key="acc.id"
                    :value="acc.id"
                    :name="acc.name"
                  >
                    {{ acc.name }}
                  </select-option>
                </select-list>

              </div>
            </div>
          </div> <!--form-items-->
          <div class="form-items" v-if="depositAcc.id !== null">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="form-data"><span>{{ getBankName }}</span></div>
          </div>
          <div class="form-items" v-if="depositAcc.id !== null">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data"><span>{{ getBankAccountName }}</span></div>
          </div>
          <div class="form-items" v-if="depositAcc.id !== null">
            <div class="form-lbl"><span>bank number</span></div>
            <div class="form-data"><span>{{ getBankNumber }}</span></div>
          </div>
          <div class="form-items" v-if="depositAcc.id !== null">
            <div class="form-lbl"><span>bank type</span></div>
            <div class="form-data"><span>{{ getBankType }}</span></div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>code</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input placeholder="code" v-model="code" />
              </div>
            </div>
          </div> <!--form-items-->
          <div class="form-items">
            <div class="form-lbl"><span>code name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input placeholder="code name" v-model="codeName" />
              </div>
            </div>
          </div> <!--form-items-->
<!--           <div class="form-items">
            <div class="form-lbl"><span>active/inactive</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input placeholder="code name" v-model="active" />
              </div>
            </div>
          </div> -->
          <div class="form-items">
            <div class="form-lbl"><span>active/inactive</span></div>
            <div class="form-data">
              <div class="input-wrap">

                <select-list
                  title="Select Status"
                  :withReset="true"
                  v-model="active"
                >
                  <select-option
                    :value="1"
                    name="active"
                  >
                    active
                  </select-option>
                  <select-option
                    :value="0"
                    name="inactive"
                  >
                    inactive
                  </select-option>
                </select-list>

              </div>
            </div>
          </div> <!--form-items-->
          <div class="form-items">
            <div class="form-lbl"><span>agent</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input-suggestion
                  @search="searchAgents"
                  v-model="agent"
                  placeholder="select agent"
                >
                  <span slot="selected">{{ agent }}</span>
                  <suggestion slot="suggestion" :key="a.id" v-for="a in agents" :value="a.id">
                    {{ a.login_id }}
                  </suggestion>
                </input-suggestion>
              </div>
            </div>
          </div> <!--form-items-->
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>

  </boxwrap>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  name: 'codes',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList
  },

  mixins: [ swal, checkAll ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    return {
      params,
      codes: [],
      deposits: [],
      showCreate: false,

      showDataLoading: false,
      isEmpty: false,
      isDataLoading: true,
      showTblSettings: false,

      selected: [],
      selectAll: false,

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],
      filterBy: [
        {
          value: 'code',
          display: 'code'
        },

        {
          value: 'name',
          display: 'code name'
        },

        {
          value: 'agent_id',
          display: 'agent id'
        },

        {
          value: 'agent_name',
          display: 'agent_name'
        },

        {
          value: 'bank_name',
          display: 'bank name'
        },

        {
          value: 'bank_account_name',
          display: 'bank account name'
        },

        {
          value: 'bank_number',
          display: 'bank number'
        }
      ],

      tblSetting: 'codes_list',
      allCols: [
        {
          value: 'id',
          display: 'no'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'code',
          display: 'code'
        },
        {
          value: 'code_name',
          display: 'code name'
        },
        {
          value: 'users_total',
          display: 'users total'
        },
        {
          value: 'users_confirm',
          display: 'users confirm'
        },
        {
          value: 'users_reject',
          display: 'users reject'
        },
        {
          value: 'users_ban',
          display: 'users ban'
        },
        {
          value: 'users_delete',
          display: 'users delete'
        },
        {
          value: 'agent_id',
          display: 'agent id'
        },
        {
          value: 'agent_name',
          display: 'agent name'
        },
        {
          value: 'wallets',
          display: 'wallets'
        },
        {
          value: 'active',
          display: 'active'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      code: '',
      codeName: '',
      agent: null,
      active: 0,
      depositAcc: {
        name: 'default',
        id: null
      }
    }
  },

  computed: {
    ...mapState('code', { allCodes: 'codes', count: 'count' }),
    ...mapState('agent', ['agents', 'count']),
    ...mapState('deposit-account', ['depositAccounts']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    getBankName () {
      let data = this.depositAccounts.find((row) => {
        return row.id === this.depositAcc.id
      })
      return data.bank_name
    },

    getBankType () {
      let data = this.depositAccounts.find((row) => {
        return row.id === this.depositAcc.id
      })
      return data.bank_type
    },

    getBankAccountName () {
      let data = this.depositAccounts.find((row) => {
        return row.id === this.depositAcc.id
      })
      return data.bank_account_name
    },

    getBankNumber () {
      let data = this.depositAccounts.find((row) => {
        return row.id === this.depositAcc.id
      })
      return data.bank_number
    }
  },

  async created ($router) {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.params = this.generate(this.params)
    this.search()
    await this.getDeposits({ status: 'active' })
    await this.getAgent({
      params: { rows: 50, sort_by: 'id', sort: 'desc' }
    })
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    },
    async showCreate (popup) {
      if (popup) {
        this.getAgent({ status: 'active',
          params: {
            rows: 30
          }
        })
      }
    }
  },

  methods: {
    ...mapActions('code', { getCodes: 'get', createCode: 'create', patch: 'update' }),
    ...mapActions('code', [ 'recover', 'delete' ]),
    ...mapActions('agent', { getAgent: 'get' }),
    ...mapActions('deposit-account', { getDeposits: 'get' }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == reset flag
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      this.isEmpty = false
      this.selected = []

      await this.getCodes({ status: this.$route.params.status, params: this.params })
      this.codes = JSON.parse(JSON.stringify(this.allCodes))

      // == set flag
      if (!this.codes.length) {
        this.isEmpty = true
      }
      this.showDataLoading = false
      this.isDataLoading = false
    },

    async searchAgents (q) {
      let params = {
        rows: 30,
        sort_by: 'id',
        sort: 'desc'
      }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
        params.sort = 'asc'
      }

      this.getAgent({
        status: 'active',
        params
      })
    },

    async create () {
      let success = async () => {
        await this.createCode({
          code: this.code,
          name: this.codeName,
          agent_id: this.agent,
          deposit_id: this.depositAcc.id,
          active: parseInt(this.active)
        })

        this.$alert('success', 'You have successfully created a code.', {}, '', 'Success')
        this.search()
        this.showCreate = false
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Code')
    },

    async update () {
      let success = async () => {
        let keys = ['active']

        this.showDataLoading = true

        let edited = this.codes.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < edited.length; x++) {
          let data = {}

          for (var key in edited[x]) {
            if (keys.indexOf(key) > -1) {
              if (key === 'active') {
                edited[x][key] = edited[x][key] ? 1 : 0
              }
              data[key] = edited[x][key]
            } // end if
          } // end for

          try {
            await this.patch({ data, id: edited[x].id })
          } catch (err) {

          }
        }
        this.selectAll = false
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to modify code(s)?', {}, { success }, 'Modify Code')
    },

    async deleteData (ids) {
      let success = async () => {
        let result = await this.delete(ids)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully removed the code(s).', {}, '', 'Success')

          this.selectAll = false
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to delete code(s)?', {}, { success }, 'Remove Code')
    },

    async restore (ids) {
      let success = async () => {
        let params = []
        let result

        ids.forEach((id) => {
          params.push({
            id: id,
            data: { deleted_at: null }
          })
        })

        result = await this.recover(params)

        if (result.status === 204) {
          this.selectAll = false
          this.$alert('success', 'You have successfully restored the code(s).', {}, '', 'Success')
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore code(s)?', {}, { success }, 'Restore Code')
    },

    setSelected (code) {
      this.$nextTick(() => {
        let result = this.allCodes.find((row) => {
          return row.id === code.id
        })

        let idx = this.selected.indexOf(code.id)

        if (code.active === result.active &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (code.active === result.active) {
          return
        }

        this.selected.push(code.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    resetTrigger (code) {
      this.$nextTick(() => {
        let idx = this.selected.indexOf(code.id)

        if (idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    }
  }
}
</script>
<style type="text/css" lang="scss" scoped>
.cbox {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.2);
  &:checked {
    background: green
  }
}
</style>
